module.exports = __webpack_public_path__ + "static/media/seatPremier.8eb5e916.png";